export default "__VITE_ASSET__Duftj37a__"